module.exports = "pegasus/assets/header.png";